import React from 'react';
import { useSelector } from 'react-redux';

import { canManageGroup, getTokenRole } from '../../../../utils/internalChatGroups';

import AddGroupParticipantsModal from './AddGroupParticipantsModal';
import DeleteGroupModal from './DeleteGroupModal';
import GroupParticipantsModal from './GroupParticipantsModal';
import RemoveGroupParticipantModal from './RemoveGroupParticipantModal';
import RenameGroupModal from './RenameGroupModal';

export const GROUP_MANAGEMENT_VIEWS = {
    PARTICIPANTS: 'participants',
    ADD_PARTICIPANTS: 'addParticipants',
    REMOVE_PARTICIPANT: 'removeParticipant',
    RENAME: 'rename',
    DELETE: 'delete'
};

/** Os modais abertos pelo menu ⋮ da janela do grupo. Um de cada vez: adicionar e
 *  remover participante voltam para a lista de participantes.
 *
 *  Ficam montados enquanto o grupo está aberto, e quem alterna é o `show`: o Modal só
 *  registra o Esc quando o `show` muda.
 */
const GroupManagement = ({ group, view, participant, onChangeView, onClose }) => {
    const loggedUserId = useSelector(state => state.auth.userData?.id);
    const accessToken = useSelector(state => state.auth.user?.access_token);

    const canManage = React.useMemo(() => {
        return canManageGroup(group, getTokenRole(accessToken), loggedUserId);
    }, [group, accessToken, loggedUserId]);

    const backToParticipants = () => onChangeView(GROUP_MANAGEMENT_VIEWS.PARTICIPANTS);

    return (
        <>
            <GroupParticipantsModal
                show={view === GROUP_MANAGEMENT_VIEWS.PARTICIPANTS}
                group={group}
                canManage={canManage}
                onClose={onClose}
                onAddParticipants={() => onChangeView(GROUP_MANAGEMENT_VIEWS.ADD_PARTICIPANTS)}
                onRemoveParticipant={item => onChangeView(GROUP_MANAGEMENT_VIEWS.REMOVE_PARTICIPANT, item)}
            />
            <AddGroupParticipantsModal
                show={view === GROUP_MANAGEMENT_VIEWS.ADD_PARTICIPANTS}
                group={group}
                onCancel={backToParticipants}
                onAdded={backToParticipants}
            />
            <RemoveGroupParticipantModal
                show={view === GROUP_MANAGEMENT_VIEWS.REMOVE_PARTICIPANT}
                group={group}
                participant={participant}
                onCancel={backToParticipants}
                onRemoved={leftGroup => leftGroup ? onClose() : backToParticipants()}
            />
            <RenameGroupModal
                show={view === GROUP_MANAGEMENT_VIEWS.RENAME}
                group={group}
                onClose={onClose}
            />
            <DeleteGroupModal
                show={view === GROUP_MANAGEMENT_VIEWS.DELETE}
                group={group}
                onClose={onClose}
            />
        </>
    );
};

export default GroupManagement;
